import { Box, Container, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Card, Typography } from '@nutrien/cxp-components';
import React from 'react';

import { IMAGE_PATH } from '../../utilities/constants';
import SignUpFlow from '../SignUpFlow';

const useStyles = makeStyles({
  box: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    minHeight: '300px',
    zIndex: 2,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    margin: '24px 32px',
    padding: 0,
  },
  logo: {
    marginBottom: '30px',
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
  },
  signupLogo: {
    width: '50%',
  },
});

const SignUp: React.FC = () => {
  const classes = useStyles();

  return (
    <Grid container justifyContent="center" alignItems="center">
      <Box className={classes.box}>
        <Card smoothShadow>
          <Container className={classes.container} maxWidth="xs">
            <img className={classes.signupLogo} src={`${IMAGE_PATH}/nutrien_dark.svg`} />
            <Typography className="aims_name" variant="h5">
              AIMS - INSPECTION APP
            </Typography>
            <SignUpFlow />
          </Container>
        </Card>
      </Box>
    </Grid>
  );
};

export default SignUp;
